import React from 'react';
import { Loader2 } from 'lucide-react';
import { pickLocalizedText } from '../../utils/localizedContent';

export default function MatchResultModal({ 
  match, 
  result, 
  setResult, 
  onSubmit, 
  onClose,
  actionLoading,
  lang,
}) {
  if (!match) return null;

  const scoreP1 = Number(result.scoreP1 || 0);
  const scoreP2 = Number(result.scoreP2 || 0);
  const winnerId =
    scoreP1 > scoreP2 ? match.player1?.user_id :
    scoreP2 > scoreP1 ? match.player2?.user_id :
    '';
  const isTie = scoreP1 === scoreP2;

  const updateScore = (key, val) => {
    const parsed = parseInt(val, 10);
    const next = Number.isFinite(parsed) ? parsed : 0;
    const nextScoreP1 = key === 'p1' ? next : Number(result.scoreP1 || 0);
    const nextScoreP2 = key === 'p2' ? next : Number(result.scoreP2 || 0);
    const nextWinner =
      nextScoreP1 > nextScoreP2 ? match.player1?.user_id :
      nextScoreP2 > nextScoreP1 ? match.player2?.user_id :
      '';
    setResult((r) => ({
      ...r,
      isDraw: false,
      winner: nextWinner,
      scoreP1: nextScoreP1,
      scoreP2: nextScoreP2,
    }));
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 px-4" 
      onClick={onClose}
    >
      <div 
        className="bg-card border border-border rounded-2xl p-6 w-full max-w-md" 
        onClick={e => e.stopPropagation()}
      >
        <h3 className="text-foreground font-bold mb-4">
          {pickLocalizedText(lang, 'Reportar Resultado', 'Report Match Result')}
        </h3>
        
        <div className="space-y-4">
          {/* Player 1 */}
          <PlayerResultRow 
            player={match.player1}
            score={result.scoreP1}
            onScoreChange={(val) => updateScore('p1', val)}
          />
          
          {/* Player 2 */}
          <PlayerResultRow 
            player={match.player2}
            score={result.scoreP2}
            onScoreChange={(val) => updateScore('p2', val)}
          />

          <div className="text-xs text-muted-foreground">
            {isTie
              ? pickLocalizedText(lang, 'No se permite empate: ajusta el marcador.', 'Draws are not allowed: adjust the score.')
              : pickLocalizedText(lang, 'Ganador detectado automáticamente.', 'Winner is detected automatically.')}
            {!isTie && winnerId && (
              <span className="text-primary font-semibold"> {' '}
                {pickLocalizedText(lang, 'Ganador', 'Winner')}: {winnerId === match.player1?.user_id ? match.player1?.name : match.player2?.name}
              </span>
            )}
          </div>
          
          <button 
            onClick={onSubmit} 
            disabled={(!winnerId || isTie) || actionLoading === 'result'}
            className="w-full btn-primary py-3 text-sm disabled:opacity-50"
            data-testid="submit-result-btn"
          >
            {actionLoading === 'result' 
              ? <Loader2 size={16} className="animate-spin mx-auto" /> 
              : pickLocalizedText(lang, 'Confirmar Resultado', 'Confirm Result')
            }
          </button>
        </div>
      </div>
    </div>
  );
}

function PlayerResultRow({ player, score, onScoreChange }) {
  return (
    <div className="flex items-center justify-between p-3 bg-muted/50 rounded-xl">
      <span className="text-foreground">{player?.name}</span>
      <input 
        type="number" 
        min={0} 
        value={score}
        onChange={e => onScoreChange(e.target.value)}
        className="w-16 bg-card border border-border rounded px-2 py-1 text-foreground text-center text-sm"
      />
    </div>
  );
}
